import Footer from '@/components/layout/footer';
import Header from '@/components/layout/header';
import { Toaster } from '@/components/ui/sonner';
import { ReactNode } from 'react';

interface BaseLayoutProps {
    children: ReactNode;
}

export default function BaseLayout({ children }: BaseLayoutProps) {
    return (
        <div className="flex min-h-dvh flex-col bg-background text-foreground">
            <Header />
            <main className="flex-grow">{children}</main>
            <Footer />
            <Toaster position="top-right" />
        </div>
    );
}
